module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/an-instance.js
// module id = 140
// module chunks = 0 1 5 7 8 9 25